import { createStyles, makeStyles } from '@material-ui/core'

const useNavLinkStyles = makeStyles(
  (theme) =>
    createStyles({
      link: {
        cursor: 'pointer',
        color: theme.palette.text.primary,

        '&:hover': {
          color: theme.palette.text.secondary
        },

        '&.active': {
          color: theme.palette.primary.main,
          fontWeight: 500
        }
      }
    }),
  {
    name: 'Navlink'
  }
)

export default useNavLinkStyles
